import axios from 'axios';

export default {
    props: {
        dataUrl: {
            type: String,
            required: true,
        },
        widgetDomain: {
            type: String,
            required: true,
        },
        heroMetricKey: {
            type: String,
            default: '',
        },
        queryParams: {
            type: Object,
            default: () => ({}),
        },
        autoFetch: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            kpiLoading: false,
            kpiError: null,
            kpiPayload: null,
            abortController: null,
        };
    },
    computed: {
        kpiHeroValue() {
            return this.kpiPayload?.hero_metric?.value ?? 0;
        },
        kpiMetrics() {
            return this.kpiPayload?.metrics ?? [];
        },
        kpiChart() {
            return this.kpiPayload?.chart ?? null;
        },
    },
    mounted() {
        if (this.autoFetch) {
            this.fetchKpi();
        }
    },
    beforeUnmount() {
        this.abortKpiRequest();
    },
    methods: {
        abortKpiRequest() {
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }
        },
        async fetchKpi(overrideParams = null) {
            this.abortKpiRequest();
            this.abortController = new AbortController();
            this.kpiLoading = true;
            this.kpiError = null;

            try {
                const response = await axios.get(this.dataUrl, {
                    params: overrideParams ?? this.queryParams,
                    signal: this.abortController.signal,
                });
                this.kpiPayload = response.data;
                this.$emit('kpi-loaded', this.kpiPayload);
            } catch (error) {
                if (axios.isCancel?.(error) || error?.code === 'ERR_CANCELED') {
                    return;
                }
                this.kpiError = error?.response?.data?.message ?? 'Unable to load KPI data.';
            } finally {
                this.kpiLoading = false;
            }
        },
    },
};
